import React, { useContext, useState } from 'react';
import { useToggleRefinement } from 'react-instantsearch';
import qs from 'qs';
import GtmFilterContext from '../../contexts/GtmFilterContext';
import GtmContext from '../../contexts/GtmContext';

const SaleItemsCheckBox = ({ label, setSaleItems, nbSaleItems }) => {
  const { value, refine } = useToggleRefinement({ attribute: 'onPromotion' });
  const currentRefinement = value && value.isRefined;
  const searchState = qs.parse(window.location.search.slice(1));
  const [oldFilters, setOldFilters] = useState(searchState.refinementList);
  const { gtm, setGtm } = useContext(GtmContext);
  const { gtmFilter, setGtmFilter } = useContext(GtmFilterContext);

  const ToggleCheck = event => {
    const currentRefinement = event.target.checked;
    let newFilters;
    setSaleItems(currentRefinement);
    refine({ isRefined: !currentRefinement });

    if (!!!currentRefinement) {
      setGtm({
        ...gtm,
        filters: {
          ...gtm.filters,
          saleItems: [{ type: 'checkbox', value: !currentRefinement ? 'yes' : 'no' }],
        },
      });
    } else if (gtm.filters) {
      setGtm({
        ...gtm,
        filters: {
          ...gtm.filters,
          saleItems: undefined,
        },
      });
    } else {
      setGtm({
        ...gtm,
      });
    }

    newFilters = {
      ...gtmFilter.newFilters,
      saleItems: [{ type: 'checkbox', value: !currentRefinement ? 'yes' : 'no' }],
    };

    setGtmFilter({
      newFilters: newFilters,
      oldFilters: oldFilters,
    });

    window.dataLayer.push({
      event: 'custom.filter.set',
      group: 'site search',
      category: 'search',
      label: !currentRefinement ? 'on' : 'off',
      name: 'saleItems',
      value: !currentRefinement,
      info: {
        element: 'checkbox',
      },
      newFilters: newFilters,
      oldFilters: oldFilters,
    });

    setOldFilters(newFilters);
  };

  return (
    <label className={`sale-items ${nbSaleItems === 0 && `hidden`}`}>
      <input type="checkbox" onChange={ToggleCheck} checked={currentRefinement} />
      {label}
      <span> ({nbSaleItems})</span>
    </label>
  );
};

export default SaleItemsCheckBox;
